import { gql } from '@grandvisionhq/graphql';
import './prices/productPriceItem.js';
import { productPriceFragment } from './prices/productPrice.js';

const offeringsFragment = gql`
  fragment offeringsFragment on Offering {
    sku
    icon
    bundledProducts
    isInsuranceReimbursable
    title {
      locale
      value
    }
    subTitle {
      locale
      value
    }
    price {
      ...productPriceFragment
    }
    bundleContentDescription {
      locale
      value
    }
    actions {
      action
      variant
    }
  }
  ${productPriceFragment}
`;

export { offeringsFragment };
//# sourceMappingURL=offerings.js.map
